/** Numbers the HUD shows, from sim telemetry. Pure. */
import { isWheelspin } from '../../sim/grip';
export const GEAR_BANDS_KMH = [0, 18, 32, 48, 64] as const;

export interface HudTelemetry { speed: number; rearSlip: number; frontLock: boolean; airborne: boolean; reversing?: boolean }
export interface HudInput { standing: boolean; body: number }

export interface HudNumbers {
  speedKmh: number; gear: number; rpm01: number; grip01: number; frontLock: boolean; stance: 'standing' | 'seated';
  lean: number; air: boolean;
  /** The same wheelspin the coach and the drill score (src/sim/grip.ts). */
  wheelspin: boolean;
  /** Paddling backwards (the back lever held at a standstill). */
  reverse: boolean;
}

/** Display gear from speed, when the engine model's gear is not available (the sim itself has no gearbox). */
export function gearFor(kmh: number): number {
  let g = 1;
  for (let i = 1; i < GEAR_BANDS_KMH.length; i++) if (kmh >= GEAR_BANDS_KMH[i]!) g = i + 1;
  return g;
}

/** rpm in [idle, redline] -> 0..1. */
export const rpmFraction = (rpm: number, idle = 1500, redline = 9800) => Math.max(0, Math.min(1, (rpm - idle) / (redline - idle)));

/** Grip 1 = hooked up; falls with rear slip above 0.3 (under a quarter at wheelspin), 0 when the front locks. */
export function gripFraction(rearSlip: number, frontLock: boolean): number {
  if (frontLock) return 0;
  return Math.max(0, Math.min(1, 1 - Math.max(0, rearSlip - 0.3) / 0.9));
}

/** `gear`: the engine sound model's gear (src/audio/model.ts) when known. */
export function hudNumbers(t: HudTelemetry, i: HudInput, rpm: number, gear?: number): HudNumbers {
  const speedKmh = Math.max(0, Math.round(Math.abs(t.speed) * 3.6));
  return {
    speedKmh, gear: gear ?? gearFor(speedKmh), rpm01: rpmFraction(rpm), grip01: gripFraction(t.rearSlip, t.frontLock),
    frontLock: t.frontLock, stance: i.standing ? 'standing' : 'seated', lean: Math.max(-1, Math.min(1, i.body)), air: t.airborne,
    wheelspin: isWheelspin(t), reverse: !!t.reversing,
  };
}

/** Segments lit on an N-segment bar. */
export const litSegments = (v01: number, n: number) => Math.round(Math.max(0, Math.min(1, v01)) * n);
